import { isNil } from 'lodash'

import { isFiniteDecimal } from '@eastcoal/common/utils/decimal'

import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'

export const quantityValidator: SchemaItem['x-validator'] = {
  required: true,
  validator(_, __, ctx) {
    const { quantity, splitCount } = ctx.form.values
    if (isNil(quantity)) {
      return '数量不能为空'
    }
    if (quantity <= 0) {
      return '数量必须大于0'
    }
    if (quantity && splitCount && !isFiniteDecimal(quantity, splitCount)) {
      return `数量（${quantity}）无法平分至 ${splitCount} 份`
    }
    return null
  }
}
